import React, { useRef, useEffect, type PropsWithChildren } from 'react';
import $ from 'jquery';
import classes from './ColorPicker.module.css';
import classnames from 'classnames';

export interface ColorPickerProps {
  color?: string;
  onChangeColor?: (color: string) => void;
  disabled?: boolean;
  small?: boolean;
  options?: any;
}

const ColorPicker: React.FC<PropsWithChildren<ColorPickerProps>> = ({
  color,
  onChangeColor,
  disabled = false,
  small = false,
  children = null,
  options = null,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const colorChanged = e => {
      if (e.color) {
        e.preventDefault();

        const value =
          e.color.displayHex === 'transparent'
            ? 'transparent'
            : `#${e.color.hex}`;

        if (!disabled && onChangeColor) onChangeColor(value);
      }
    };

    const element = ref.current;
    if (element) {
      const $element = $(element);
      // @ts-ignore
      $element.colorPicker(options);
      $element.on('changeColor', colorChanged);
    }

    return () => {
      if (element) {
        $(element).off('changeColor');
      }
    };
  }, [onChangeColor, disabled, options]);

  if (children)
    return (
      <div
        className={small ? 'small-colorpicker-trigger' : 'color-picker-trigger'}
        ref={ref}
        data-color={color}
      >
        {children}
      </div>
    );
  else
    return (
      <div
        ref={ref}
        data-color={color}
        style={{ backgroundColor: color }}
        className={classnames({
          [classes.colorInput]: !small,
          disabled: disabled,
          'small-colorpicker-trigger': small,
        })}
      />
    );
};

export default ColorPicker;
